/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringTranslationsOptionsFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringTranslationsOptionsToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringTranslationsOptions';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString(value) {
    if (!('Default' in value) || value['Default'] === undefined)
        return false;
    if (!('Translations' in value) || value['Translations'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Default': json['Default'],
        'Translations': FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringTranslationsOptionsFromJSON(json['Translations']),
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Default': value['Default'],
        'Translations': FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedStringTranslationsOptionsToJSON(value['Translations']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLocalizedString.js.map